<template>
  <div class="process-actions">
    <div class="action-btns">
      <Button theme="primary" @click="openLink">
        {{ process.btn }}
      </Button>
      <Button v-if="!hiddenReturnBtn" @click="close">
        {{ $t('trade.acct-status.button-return') }}
      </Button>
    </div>
    <a
      v-if="showProblemLink"
      :href="HELP_LINK | langParam"
      class="action-link"
      target="_blank"
    >
      {{ $t('trade.acct-status.problem-link') }}
    </a>
  </div>
</template>
<script>
import Button from 'com/Button'
import { HELP_LINK } from 'const/link'

export default {
  name: 'ProcessActions',
  components: { Button },
  props: {
    process: Object,
    showProblemLink: {
      type: Boolean,
      default: true
    },
    hiddenReturnBtn: Boolean
  },
  data() {
    return {
      HELP_LINK
    }
  },
  methods: {
    openLink() {
      window.open(this.process.link, '_blank')
    },
    close() {
      this.$emit('back')
    }
  }
}
</script>
<style lang="less" scoped>
@import '~uikit';
.process-actions {
  width: 100%;
  padding: 15px 40px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  .action-btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-bottom: 15px;
  }
  /deep/ .tt-button {
    min-width: 100px;
    &:last-child {
      margin-right: 0;
    }
  }
  a {
    color: @link-color;
  }
}
</style>
